/* Stacks — site-wide behaviour: drawer, reveal, quick add, cart count, toast. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // ---------- money ----------
  window.formatMoney = (cents) => {
    const fmt = (window.Stacks && Stacks.money) || '{{amount}}';
    const n = (cents / 100);
    const two = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, '');
    const zero = Math.round(n).toLocaleString('en-US');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k.includes('no_decimals') ? zero : two);
  };

  // ---------- toast ----------
  let toastTimer;
  window.toast = (html) => {
    const el = $('.toast');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 4200);
  };

  // ---------- cart count ----------
  window.refreshCartCount = async () => {
    try {
      const cart = await fetch((window.Stacks?.routes.cart || '/cart') + '.js').then(r => r.json());
      const n = window.cartLineCount ? window.cartLineCount(cart) : cart.item_count;
      $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = n === 0; });
      return cart;
    } catch (e) { return null; }
  };

  // ---------- header: shrink on scroll, hide when scrolling down ----------
  let hdr = $('[data-header]');
  document.addEventListener('shopify:section:load',()=>{hdr=$('[data-header]');});
  if (hdr) {
    let lastY = scrollY, ticking = false;
    const onScroll = () => {
      const y = scrollY;
      hdr.classList.toggle('is-scrolled', y > 10);
      const menuOpen = document.querySelector('.drawer.is-open, .nav-item.is-open');
      hdr.classList.toggle('is-hidden', !menuOpen && y > 320 && y > lastY + 4);
      if (y < lastY - 4) hdr.classList.remove('is-hidden');
      lastY = y; ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    onScroll();
  }

  // ---------- top strip rotator ----------
  $$('[data-rotator]').forEach(r => {
    const msgs = $$('.strip__msg', r);
    if (msgs.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => {
      // nothing to see while the tab is in the background or the strip is scrolled away
      if (document.hidden || r.getBoundingClientRect().bottom < 0) return;
      const cur = msgs[i]; i = (i + 1) % msgs.length; const next = msgs[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      next.classList.remove('is-out'); next.classList.add('is-on');
      setTimeout(() => cur.classList.remove('is-out'), 600);
    }, 4000);
  });

  // ---------- desktop dropdowns: hover with intent + click + keyboard ----------
  const setMenu=(item,open)=>{item.classList.toggle('is-open',open);$('[data-drop-toggle]',item)?.setAttribute('aria-expanded',String(open));};
  const initMenus=(root=document)=>$$('.nav-item.has-drop',root).forEach(item=>{
    if (item.dataset.dropReady) return; item.dataset.dropReady='1';
    const btn = $('[data-drop-toggle]', item);
    let t;
    const set=open=>setMenu(item,open);
    item.addEventListener('mouseenter', () => { clearTimeout(t); $$('.nav-item.is-open').forEach(o => o !== item && setMenu(o,false)); set(true); });
    item.addEventListener('mouseleave', () => { t = setTimeout(() => set(false), 180); });
    btn.addEventListener('click', () => set(!item.classList.contains('is-open')));
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) set(false); });
  });
  initMenus();
  document.addEventListener('shopify:section:load',e=>initMenus(e.target));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.nav-item.is-open').forEach(i => { setMenu(i,false); $('[data-drop-toggle]', i)?.focus(); });
  });

  // ---------- floating WhatsApp ----------
  $$('[data-wa]').forEach(wa => {
    const card = $('.wa__card', wa);
    const fab = $('[data-wa-toggle]', wa);
    const nudge = $('[data-wa-nudge]', wa);
    const status = $('[data-wa-status]', wa);
    const input = $('#wa-text', wa);
    const store = { get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} } };

    // reply hours → "online" or "away"
    const [from, to] = String(wa.dataset.hours || '10-22').split('-').map(Number);
    const h = new Date().getHours();
    if (!(h >= from && h < to)) { wa.classList.add('is-away'); status.textContent = wa.dataset.away; }

    const openWA = (text) => {
      const msg = `${text}\n\n${wa.dataset.pageLabel}: ${location.origin}${location.pathname}`;
      window.open(`https://wa.me/${wa.dataset.number}?text=${encodeURIComponent(msg)}`, '_blank', 'noopener');
    };
    let typedTimer;
    const setOpen = (open) => {
      wa.classList.toggle('is-open', open);
      fab.setAttribute('aria-expanded', open);
      card.setAttribute('aria-hidden', !open);
      if (open) {
        nudge.hidden = true; store.set('wa-nudged', '1'); wa.classList.remove('is-hint');
        clearTimeout(typedTimer);
        if (!wa.classList.contains('is-typed')) typedTimer = setTimeout(() => wa.classList.add('is-typed'), 900);
        setTimeout(() => { if (matchMedia('(hover: hover)').matches) input.focus(); }, 950);
      }
    };
    fab.addEventListener('click', () => setOpen(!wa.classList.contains('is-open')));
    $('[data-wa-close]', wa).addEventListener('click', () => { setOpen(false); fab.focus(); });
    $$('[data-wa-msg]', wa).forEach(b => b.addEventListener('click', () => openWA(b.dataset.waMsg)));
    $('[data-wa-form]', wa).addEventListener('submit', (e) => { e.preventDefault(); if (input.value.trim()) { openWA(input.value.trim()); input.value = ''; } });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && wa.classList.contains('is-open')) setOpen(false); });
    document.addEventListener('click', (e) => { if (wa.classList.contains('is-open') && !wa.contains(e.target)) setOpen(false); });

    // gentle nudge once per session, after the customer has had time to look around
    if (!store.get('wa-nudged')) {
      setTimeout(() => {
        if (wa.classList.contains('is-open')) return;
        nudge.hidden = false; wa.classList.add('is-hint');
        setTimeout(() => wa.classList.remove('is-hint'), 3500);
      }, 12000);
    }
    $('[data-wa-nudge-x]', wa).addEventListener('click', () => { nudge.hidden = true; store.set('wa-nudged', '1'); });
    nudge.addEventListener('click', (e) => { if (!e.target.closest('button')) setOpen(true); });
  });

  // ---------- phone sticky CTA: appears once the first screen has scrolled away ----------
  const mcta = $('[data-mcta]');
  if (mcta) {
    const hero = $('.hero, .phero') || null;
    const limit = () => (hero ? hero.getBoundingClientRect().bottom + window.scrollY : 480);
    let edge = limit();
    const tick = () => { const on = window.scrollY > edge - 60; mcta.classList.toggle('is-on', on); mcta.setAttribute('aria-hidden', String(!on)); mcta.tabIndex = on ? 0 : -1; };
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', () => { edge = limit(); tick(); });
    tick();
  }

  // ---------- footer columns: open on desktop, accordion on phones ----------
  const mq = matchMedia('(max-width: 760px)');
  const syncFooter = () => $$('.ftr__col').forEach(d => { d.open = !mq.matches; });
  syncFooter(); mq.addEventListener?.('change', syncFooter);

  // ---------- drawer ----------
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-drawer-open]');
    const close = e.target.closest('[data-drawer-close]');
    if (open) {
      const d = document.getElementById(open.dataset.drawerOpen);
      if (d) d._returnFocus=document.activeElement;
      d?.classList.add('is-open'); d?.setAttribute('aria-hidden', 'false');
      open.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      hdr?.classList.remove('is-hidden');
      setTimeout(() => d?.querySelector('[data-autofocus]')?.focus(), 250);
    }
    // close the sheet when following a link inside it
    const inSheetLink = e.target.closest('.drawer.is-open a[href]');
    if (inSheetLink && !inSheetLink.target) {
      const d = inSheetLink.closest('.drawer');
      d.classList.remove('is-open'); document.body.style.overflow = '';
    }
    if (close) {
      const d = close.closest('.drawer');
      d?.classList.remove('is-open'); d?.setAttribute('aria-hidden', 'true');
      $$('[data-drawer-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
      document.body.style.overflow = '';
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open [data-drawer-close]').forEach(b => b.click());
  });

  // ---------- reveal ----------
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    const watch = (root = document) => $$('[data-reveal]:not(.is-in)', root).forEach((el, i) => {
      el.style.transitionDelay = (el.dataset.revealDelay || Math.min(i % 4, 3) * 80) + 'ms';
      io.observe(el);
    });
    watch();
    document.addEventListener('shopify:section:load', (e) => watch(e.target));
    // markup fetched after load (recommendations, recently viewed) has to be handed over,
    // otherwise those cards sit at opacity 0 forever
    window.Stacks = Object.assign(window.Stacks || {}, { reveal: watch });
    document.addEventListener('stacks:content', (e) => watch(e.target));
  } else {
    $$('[data-reveal]').forEach(el => el.classList.add('is-in'));
  }

  // ---------- pause looping animations that are off screen ----------
  // A marquee or a sweeping highlight repaints every frame even when nobody can see it,
  // which costs battery on phones and can jank the scroll.
  if ('IntersectionObserver' in window) {
    const pio = new IntersectionObserver((entries) => {
      entries.forEach(en => en.target.classList.toggle('is-paused', !en.isIntersecting));
    }, { rootMargin: '120px' });
    const pause = (root = document) => $$('[data-pause-offscreen]', root).forEach(el => pio.observe(el));
    pause();
    document.addEventListener('shopify:section:load', (e) => pause(e.target));
  }

  // ---------- quantity steppers ----------
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const min = +input.min || 0;
    input.value = Math.max(min, (+input.value || 0) + (+b.dataset.qty));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

})();
